var React = require('react');

function IconGenericBox (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm1.25-26.485a2.784 2.784 0 0 0-2.5 0L7.548 9.153A2.82 2.82 0 0 0 6 11.673v8.654a2.818 2.818 0 0 0 1.536 2.528l7.203 3.638c.79.4 1.722.4 2.513 0l7.2-3.637A2.82 2.82 0 0 0 26 20.336v-8.663a2.82 2.82 0 0 0-1.55-2.521l-7.2-3.637z","key":0}),React.createElement("g",{"fillRule":"nonzero","fill":"currentColor","key":1},[React.createElement("path",{"d":"M25.557 9.163a1 1 0 1 1 .899 1.787l-10.007 5.034a1 1 0 0 1-.9 0l-9.945-5.035a1 1 0 0 1 .903-1.785l9.494 4.807 9.556-4.808z","key":0}),React.createElement("path",{"d":"M17 27.758a1 1 0 0 1-2 0V15.09a1 1 0 1 1 2 0v12.667z","key":1})])]));
}

IconGenericBox.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = IconGenericBox;

IconGenericBox.default = IconGenericBox;
